import { MARQUEE_WORDS } from "../data/site";

export const Marquee = ({ testId = "marquee" }) => {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      data-testid={testId}
      className="marquee-host mask-fade-x relative overflow-hidden border-y border-white/[0.07] bg-[#0d1219] py-5 sm:py-6"
    >
      <div className="animate-marquee flex w-max items-center gap-7 whitespace-nowrap sm:gap-10">
        {[...row, ...row].map((w, i) => (
          <span key={i} className="flex items-center gap-7 sm:gap-10">
            <span
              className={`font-cond text-2xl font-bold uppercase tracking-[0.06em] sm:text-4xl lg:text-5xl ${
                i % 3 === 1
                  ? "text-transparent [-webkit-text-stroke:1px_rgba(197,160,89,0.55)]"
                  : "text-[#e8e1d2]"
              }`}
            >
              {w}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#c5a059]" />
          </span>
        ))}
      </div>
    </div>
  );
};
